export default __webpack_public_path__ + "static/media/resume.163cd5e4.pdf";